import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { useAuth } from "../provider/AuthProvider";

import MainLayout from "../pages/MainLayout"; // Layout principal de l'application

import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Logout from "../pages/Logout";

import Home from "../pages/Home";
import About from "../pages/About";
import Page404 from "../pages/Page404";

import SkillTemplates from "../pages/skill/SkillTemplates";
import SkillTemplate from "../pages/skill/SkillTemplate";
import SkillTemplateNew from "../pages/skill/SkillTemplateNew";

import SpellTemplates from "../pages/spell/SpellTemplates";
import SpellTemplate from "../pages/spell/SpellTemplate";
import SpellTemplateNew from "../pages/spell/SpellTemplateNew";

import JobTemplates from "../pages/job/JobTemplates";
import JobTemplate from "../pages/job/JobTemplate";
import JobTemplateNew from "../pages/job/JobTemplateNew";

import Characters from "../pages/character/Characters";
import Character from "../pages/character/Character";
import CharacterNew from "../pages/character/CharacterNew";

import Campaigns from "../pages/campaign/Campaigns";
import Campaign from "../pages/campaign/Campaign";
import CampaignNew from "../pages/campaign/CampaignNew";

import Addxp from "../pages/Addxp";

// TODO : Remove test
import LoginFast from "../pages/LoginFast";

const Routing = () => {
  // Importation des variables globales
  const { userName, isAdmin } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          {!userName && (
            <>
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              {/* TODO : Remove test LoginFast */}
              <Route path="login-fast" element={<LoginFast />} />
            </>
          )}
          {userName && (
            <>
              <Route path="skill" element={<SkillTemplates />} />
              <Route
                path="skill/:idSkillTemplate"
                element={<SkillTemplate />}
              />
              <Route path="spell" element={<SpellTemplates />} />
              <Route
                path="spell/:idSpellTemplate"
                element={<SpellTemplate />}
              />
              <Route path="job" element={<JobTemplates />} />
              <Route path="job/:idJobTemplate" element={<JobTemplate />} />
              <Route path="characters" element={<Characters />} />
              <Route path="character/new" element={<CharacterNew />} />
              <Route path="character/:idCharacter" element={<Character />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaign/new" element={<CampaignNew />} />
              <Route path="campaign/:idCampaign" element={<Campaign />} />
            </>
          )}
          {isAdmin && (
            <>
              <Route path="admin" element={<Home />} />
              <Route path="addxp" element={<Addxp />} />
              <Route path="skill/new" element={<SkillTemplateNew />} />
              <Route path="spell/new" element={<SpellTemplateNew />} />
              <Route path="job/new" element={<JobTemplateNew />} />
            </>
          )}
          <Route path="logout" element={<Logout />} />
          {/* Page 404 si l'url n'est pas reconnue */}
          <Route path="*" element={<Page404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
